import React, { Component } from 'react'
import Switch from "react-switch";
import { Notifications } from '../../common/notification';
import Axios from 'axios';
import { getUser } from '../../../actions/session'
import { GATEWAY_LISTING, GATEWAY_UPDATE } from '../../../config/rest_endpoints';

class UpdateGateway extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User:getUser(),
            switched:true,
            ip:'',
            port:5060,
            sessions:'',
            cps:'',
            prefix:'',
            id:'',
            isLoad:false
        }
        this.onHandleChange = this.onHandleChange.bind(this)
        this.onUpdateGateways = this.onUpdateGateways.bind(this)
        this.toggleSwitch = this.toggleSwitch.bind(this)
    }

 
    componentWillReceiveProps(newProps) {
        const {previousData} = newProps
        this.setState({
            switched:previousData.status,
            ip:previousData.ip,
            port:previousData.port === undefined ? '' :previousData.port,
            sessions:previousData.sessions === undefined ? '' : previousData.sessions ,
            cps:previousData.cps === undefined ? '' :previousData.cps,
            prefix:previousData.prefix === undefined ? '' : previousData.prefix,
            id:previousData.id
        })
    }

    toggleSwitch() {
        this.setState({switched:!this.state.switched})
    }

    onHandleChange(e) {
        this.setState({
            [e.target.name]:e.target.value
        })
    }

    onUpdateGateways() {
         //
         const {User,switched,ip,port, sessions,cps,prefix,id} = this.state
         var payload = {
                "status":switched,
                "ip":ip,
                "port":parseInt(port),
                "cps" :cps === '' ? null : parseInt(cps),
                "sessions": sessions === '' ? null : parseInt(sessions),
                "prefix":prefix === '' ? null : prefix
         }
         console.log("payload", payload)
        this.setState({ isLoad: true })
         var headers = { 'Authorization': "Bearer " + User.token }
         Axios.put(`${GATEWAY_UPDATE}/${id}/update`, payload, { headers }).then(res => {
             if (res) {
                console.log('res :>> ', res);
                Notifications.notify("Gateway created", "Success", "success")
                this.setState({ isLoad: false, ip:'',port:'',sessions:'',cps:'',prefix:''})
                this.props.syncList()
                this.props.close()
                
             }
             else {
                 Notifications.notify("failed carrier update", "Failed", "error")
             }
         }).catch(err => {
             var msessage = err.response.data.message
             this.setState({ isLoad: false })
             Notifications.notify(msessage, "Failed", "error")
         })
 
       
    }
    
    render() {
        const{switched,ip,port,sessions,cps,prefix} = this.state

        const labelStyle = {
            fontWeight: '500',
            fontSize: '13px',
            color: '#475569',
            marginBottom: '6px'
        };

        return (
            <div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>IP</label>
                            <input type="text" className="form-control" name="ip" value={ip} onChange={this.onHandleChange} placeholder="Enter IP" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Port</label>
                            <input type="number" className="form-control" name="port" value={port} onChange={this.onHandleChange} placeholder="Enter Port" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Sessions</label>
                            <input type="number" className="form-control" name="sessions" value={sessions} onChange={this.onHandleChange} placeholder="Enter session" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>CPS</label>
                            <input type="number" className="form-control" name="cps" value={cps} onChange={this.onHandleChange} placeholder="Enter cps" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Prefix</label>
                            <input type="number" className="form-control" name="prefix" value={prefix} onChange={this.onHandleChange} placeholder="Enter prefix" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group" style={{marginTop:'4px'}}>
                            <label style={labelStyle}>Status</label>
                            <div style={{marginTop:'4px'}}>
                                <Switch onChange={this.toggleSwitch} checked={switched} onColor="#10B981" offColor="#CBD5E1" height={22} width={44} handleDiameter={18} />
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{borderTop:'1px solid #E2E8F0',marginTop:'16px',paddingTop:'20px',display:'flex',justifyContent:'flex-end'}}>
                    <button
                        type="submit"
                        onClick={this.onUpdateGateways}
                        style={{
                            background: this.state.isLoad ? '#94A3B8' : 'linear-gradient(135deg, #10B981, #059669)',
                            color: '#FFFFFF',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '10px 24px',
                            fontSize: '13px',
                            fontWeight: '600',
                            cursor: this.state.isLoad ? 'not-allowed' : 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            boxShadow: this.state.isLoad ? 'none' : '0 4px 12px rgba(16, 185, 129, 0.3)',
                            transition: 'all 200ms ease'
                        }}
                    >
                        Update Gateway
                        <i className={this.state.isLoad ? "icon-spinner4 spinner" : "icon-file-plus"} style={{fontSize:'14px'}}></i>
                    </button>
                </div>
            </div>
        )
    }
}
export default UpdateGateway